import {
  ChangeDetectorRef,
  Component,
  Input,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { Operations } from '../../../../interface/company-client.interface';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ModalCommentComponent } from 'src/app/pages/dashboards/modals/modal-comment/modal-comment.component';
import {
  OperationAssociatedToMinuteVM,
  RegisterMinuteWithOperationsVm,
} from '../../../../interface/company-minutes.interface';
import { RegisterMinuteWithOpsComponent } from '../../../../modals/register-minute-with-ops/register-minute-with-ops.component';
import { DetalleOperationsComponent } from '../../../information/detalle-operations/detalle-operations.component';
import { CdkContextMenuTrigger } from '@angular/cdk/menu';

@Component({
  selector: 'app-create-operations',
  templateUrl: './create-operations.component.html',
  styleUrls: ['./create-operations.component.scss'],
})
export class CreateOperationsComponent {
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(CdkContextMenuTrigger)
  menu!: CdkContextMenuTrigger;
  @Input() operations: Operations[];
  @Input() companyId: number;

  public dataSource!: MatTableDataSource<Operations>;
  public existenDatos: boolean = true;
  public rutCompany: number;
  public displayedColumns: string[] = [
    'selection',
    'folio',
    'fechaCesion',
    'createdAt',
    'rate',
    'allInRate',
    // 'dateAcept',
    'financedAmount',
    'downPaymentPercentage',
    'operationState',
    'transferAmount',
    'plazo',
    'comments',
    'executiveName',
    'lastUpdate',
  ];

  public selection = new SelectionModel<Operations>(
    true,
    [],
    false,
    (op1, op2) => op1.invoiceOperationId === op2.invoiceOperationId
  );

  constructor(public dialog: MatDialog, private cdr: ChangeDetectorRef) {
    this.dataSource = new MatTableDataSource<Operations>([]);
  }

  ngOnInit() {
    this.paginator._intl.itemsPerPageLabel = 'items por pagina';

  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['operations']) {
      const updatedOperations = changes['operations'].currentValue;
      if (updatedOperations) {
        this.setDataSource(this.operations);
        this.updateSelectionModel(this.selection.selected, this.operations);
      }
    }
  }

  setDataSource(dataSource: Operations[]) {
    this.dataSource = new MatTableDataSource<Operations>(dataSource);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;    
  }

  openDialog(value: string) {
    console.log(value);
    const dialogRef = this.dialog.open(ModalCommentComponent, {
      data: value,
      width: '60%',
    });
  }



  private updateSelectionModel(
    selectedOps: Array<Operations>,
    newData: Array<Operations>
  ) {
    selectedOps.forEach((op) => {
      const foundOp = newData.find(
        (i) => i.invoiceOperationId === op.invoiceOperationId
      );
      if (!foundOp) {
        this.selection.deselect(op);
      }
    });
    this.cdr.detectChanges();
  }

  public openCreateMinuteWithOps() {
    const data: RegisterMinuteWithOperationsVm = {
      clientCompanyId: this.companyId,
      operations: this.selection.selected.map(
        (o) =>
          <OperationAssociatedToMinuteVM>{
            invoiceOperationId: o.invoiceOperationId,
            folio: o.folio,
            fechaCesion: o.fechaCesion,
            financedAmount: o.financedAmount,
            transferAmount: o.transferAmount,
          }
      ),
    };
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.width = '50vw';
    dialogConfig.height = '650px';
    dialogConfig.maxWidth = '90vw';
    dialogConfig.maxHeight = '90vh';
    dialogConfig.data = data;

    const dialogRef = this.dialog.open(
      RegisterMinuteWithOpsComponent,
      dialogConfig
    );
  }

  public openDetalleOperation(value: Operations) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.width = '60%';
    dialogConfig.maxWidth = '90vw';
    dialogConfig.height = '600px';
    dialogConfig.maxHeight = '90vh';
    dialogConfig.data = value;

    const dialogRef = this.dialog.open(
      DetalleOperationsComponent,
      dialogConfig
    );
  }
}
